// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const TaxRatesPage = lazy(() => import('./pages/TaxRatesPage'));
const TaxCalculationPage = lazy(() => import('./pages/TaxCalculationPage'));
const TaxReturnsPage = lazy(() => import('./pages/TaxReturnsPage'));
const TaxAuditTrailPage = lazy(() => import('./pages/TaxAuditTrailPage'));
const WithholdingTdsPage = lazy(() => import('./pages/WithholdingTdsPage'));
const TaxExemptionsPage = lazy(() => import('./pages/TaxExemptionsPage'));

export const TaxRoutes: RouteObject = {
  path: 'tax',
  element: <ModuleGuard moduleId="finance.tax" />,
  children: [
    { path: 'tax-rates', element: <TaxRatesPage />, handle: { crumb: 'Tax Rates' } },
    { path: 'tax-calculation', element: <TaxCalculationPage />, handle: { crumb: 'Tax Calculation' } },
    { path: 'tax-returns', element: <TaxReturnsPage />, handle: { crumb: 'Tax Returns' } },
    { path: 'tax-audit-trail', element: <TaxAuditTrailPage />, handle: { crumb: 'Tax Audit Trail' } },
    { path: 'withholding-tds', element: <WithholdingTdsPage />, handle: { crumb: 'Withholding Tax (TDS)' } },
    { path: 'tax-exemptions', element: <TaxExemptionsPage />, handle: { crumb: 'Tax Exemptions' } },
  ],
};
